/**
 * Created by vlad.p on 10/13/2017.
 */

import { AfterViewInit, Component, ElementRef, OnInit, Renderer2, ViewChild, ViewEncapsulation } from "@angular/core";
import * as ps from "perfect-scrollbar";
import { ActivatedRoute, Router } from "@angular/router";
import { OrderService } from "../../../services/orderService";
import { CalculatorHelper } from "../../../common/helpers/calculatorHelper";
import { Order } from "../../../objects/orders/order";
import { CalculatorComponent } from "../calculator.component";
import { OrderStatus } from "../../../objects/orders/orderStatus";
import { ExtraData } from "../../../objects/extraData/extraData";
import { OrderContentService } from "../../../services/orderContentService";
import { ExtraDataService } from "../../../services/extraDataService";
import { ReferenceType } from "../../../objects/extraData/extraDataSearchRequest";
import { OrderOptions } from "../../../objects/orders/orderOptions";

@Component({
    selector: "public-calculator",
    templateUrl: "./public-calculator.component.html",
    moduleId: module.id.toString(),
    styleUrls: ['../../../../theme/css/select.css',
        '../../../../node_modules/select2/dist/css/select2.css',
        '../../../../node_modules/@swimlane/ngx-datatable/release/index.css',
        '../../../../node_modules/@swimlane/ngx-datatable/release/assets/icons.css',
        '../../../../node_modules/@swimlane/ngx-datatable/release/themes/material.css',
        '../../../../node_modules/@qontu/ngx-inline-editor/themes/bootstrap.css',
        '../../../../theme/css/datatable.css'],
    encapsulation: ViewEncapsulation.None
})
export class PublicCalculatorComponent implements OnInit, AfterViewInit {

    @ViewChild("publicPanel") publicPanelRef: ElementRef;

    @ViewChild('publicCalculator') publicCalculator: CalculatorComponent;

    public order: Order = new Order();
    public extraData: ExtraData = new ExtraData();

    public isV2: boolean = false;

    constructor(private renderer: Renderer2, private route: ActivatedRoute, public orderService: OrderService, private extraDataService: ExtraDataService,
                public router: Router) {
    }

    ngOnInit(): void {
        if (this.route.snapshot.data.order != null) {
            this.order = this.route.snapshot.data.order.Data;
            this.order.CalculatorType = CalculatorHelper.getCalculatorType(this.order.Locations);
        }

        if (this.route.snapshot.data.extraData != null && this.route.snapshot.data.extraData.Data != null) {
            let marketings = this.route.snapshot.data.extraData.Data.filter((x: ExtraData) => x.Name == 'marketing text');

            marketings.sort((e1: ExtraData, e2: ExtraData) => {
                return new Date(e1.Created).getTime() - new Date(e2.Created).getTime();
            });

            let extr = marketings[0];

            if (extr)
                this.extraData = extr;
        }

        if (this.router.url.includes('/calculator2/public'))
            this.isV2 = true;

        this.getExtraData();
    }

    ngAfterViewInit(): void {

        if (this.order.Id)
            this.publicCalculator.calculatorWizard.nextTab();

        let spinner = document.getElementById("spinner");
        this.renderer.addClass(spinner, "hide");
    }

    private async getExtraData(): Promise<void> {
        if (!this.order || !this.order.Id || !this.order.Customer || !this.order.Customer.Id)
            return null;

        if (this.extraData.Name)//if extraData exists
            return null;

        try {
            let response = await this.extraDataService.getByRefIdandRefType(this.order.Customer.Id.toString(), ReferenceType.Order);

            if (!response.Data || response.Data.length == 0)
                return;

            let extr = response.Data.find(x=> x.Name == 'marketing text');

            if(extr)
                this.extraData = extr;
        }
        catch (e) {
            console.log(e);
        }
    }

    public restoreOrder(event: boolean){
        if(event){
            this.order = new Order();
        }
    }

}



// WEBPACK FOOTER //
// ./app/components/calculator/public/public-calculator.component.ts